import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { Link } from 'react-router-dom';

import { changeOpinionType, fetchOpinionTerms } from '../../actions';

class OpinionTypes extends Component {

	constructor( props ) {
		super( props );
		this.handleOpinionTypeChange = this.handleOpinionTypeChange.bind( this );
		this.state = {
			showOpinionTypes: true
		};
		this.toggleShowOpinionTypes = this.toggleShowOpinionTypes.bind( this );
	}

	componentWillMount() {
		if ( !this.props.opinionTypes.length ) {
			this.props.fetchOpinionTerms( 'opinion_type' );
		}

		const { location } = this.props;
		const params = new URLSearchParams( location.search );
		let selectedTypes = params.get( 'opinions' ) ? params.get( 'opinions' )
		                                                     .split( ',' ) : [];
		this.props.changeOpinionType( selectedTypes );
	}

	renderFilterButton( type ) {
		const activeStatus = (parseInt( type.id ) === parseInt( this.props.selectedType )
		                     ) ? 'active' : '';
		return (<Link to={ `/opinions-library/type/${ type.slug }/` }
		              className={ `btn btn-lg ${ activeStatus }` }
		              id={ `term-${ type.id }` } data-cat={ type.id }
		              key={ type.id }>{ type.name }</Link>
		);
	}

	toggleShowOpinionTypes() {
		this.setState( { showOpinionTypes: !this.state.showOpinionTypes } );
	}

	handleOpinionTypeChange( typeId ) {
		const { history, location, opinionTypes } = this.props;
		const params = new URLSearchParams( location.search );
		let selectedTypes = params.get( 'opinions' ) ? params.get( 'opinions' )
		                                                     .split( ',' ) : [];

		if ( typeId === 'all' ) {
			selectedTypes = [];
		} else {
			if ( selectedTypes.includes( String( typeId ) ) ) {
				// Remove the typeId if it's already selected
				selectedTypes = selectedTypes.filter( id => String( id ) !== String( typeId ) );
			} else {
				// Add the new typeId to the array
				selectedTypes.push( typeId );
			}

			// Check if all types are selected
			if ( selectedTypes.length === opinionTypes.length ) {
				selectedTypes = []; // Set to empty array (equivalent to 'All')
			}
		}

		const searchParams = new URLSearchParams( location.search );
		if ( selectedTypes.length > 0 ) {
			searchParams.set( 'opinions', selectedTypes.join( ',' ) );
		} else {
			searchParams.delete( 'opinions' );
		}

		history.push( {
			              pathname: '/opinions-library',
			              search  : searchParams.toString()
		              } );

		// Join the array back into a comma-separated string
		this.props.changeOpinionType( selectedTypes.join( ',' ) );
	}

	render() {
		// const selectedTypes = this.props.selectedType ? this.props.selectedType.split(',') : [];
		const params = new URLSearchParams( this.props.location.search );
		const currentSelectedTypes = params.get( 'opinions' )
		                             ? params.get( 'opinions' )
		                                     .split( ',' )
		                             : [];
		const defaultChecked = currentSelectedTypes.length === 0;

		return (<div>
				<div className="sidebar-heading-container">
					<h2 className="sidebar-heading">Opinion Types</h2>
					<i className={ `fa-solid fa-chevron-${ this.state.showOpinionTypes
					                                       ? 'up'
					                                       : 'down' } filter-toggle-icon` }
					   onClick={ this.toggleShowOpinionTypes }></i>
				</div>
				{ this.state.showOpinionTypes && (<Fragment>
						<p className="sidebar-description">
							Please select the section you want to explore.
						</p>
						<div>
							<div className="filter-checkbox-container"
							     onClick={ () => this.handleOpinionTypeChange( 'all' ) }>
								<label className="custom-checkbox no-parent"
								       htmlFor="checkbox-all">
									<input
										type="checkbox"
										id="checkbox-all"
										checked={ defaultChecked }
										onChange={ () => this.handleOpinionTypeChange( 'all' ) }
										className={ `${ defaultChecked
										                ? 'active'
										                : '' }` }
									/>
									<span className="checkmark"></span>
								</label>
								<label htmlFor="checkbox-all"
								       dangerouslySetInnerHTML={ { __html: 'All' } }/>
							</div>
							{ this.props.opinionTypes.map( ( type, index ) => {
								const isChecked = currentSelectedTypes.includes( String( type.id ) );
								return (
									<div className="filter-checkbox-container"
									     onClick={ () => this.handleOpinionTypeChange( type.id ) }
									     key={ index }>
										<label
											className="custom-checkbox no-parent"
											htmlFor={ `checkbox-${ index }` }>
											<input
												type="checkbox"
												id={ `checkbox-${ index }` }
												checked={ isChecked }
												onChange={ () => this.handleOpinionTypeChange( type.id ) }
												className={ `${ isChecked
												                ? 'active'
												                : '' }` }/>
											<span className="checkmark"></span>
										</label>
										<label htmlFor={ `checkbox-${ index }` }
										       dangerouslySetInnerHTML={ { __html: type.name } }/>
									</div>
								);
							} ) }
						</div>
					</Fragment>
				) }

			</div>
		);
	}

}

function mapStateToProps( { opinionTypes, selectedType } ) {
	return { opinionTypes, selectedType };
}

export default withRouter( connect( mapStateToProps, {
	fetchOpinionTerms, changeOpinionType
} )( OpinionTypes ) );